import { AxiosInstanceBuilder } from '@digibricks/plugin-axios';
import { REPORT_API, ReportApi } from './data-sources';
import { REPORT_REPOSITORY_WEB_CONFIG } from './report-repository-web.config';
export var apiProviders = [{
  provide: AxiosInstanceBuilder,
  useFactory: function useFactory(config) {
    return new AxiosInstanceBuilder().withBaseUrl(config.baseUrl).withTimeout(config.timeout).withHeaders({
      Authorization: "Bearer ".concat(config.accessToken)
    });
  },
  inject: [REPORT_REPOSITORY_WEB_CONFIG]
}, {
  provide: REPORT_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new ReportApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}];